import React from "react";
import { useT } from '~app/BundleProvider';

const EnterIcon = ({ className }) => {
  const t = useT();
  return (
    <svg
      className={className}
      width="131px"
      height="136px"
      viewBox="0 0 131 136"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      aria-label={t("last-page")}
    >
      <defs />
      <g
        id="Interactive-2"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        transform="translate(-1725.000000, -1024.000000)"
      >
        <g id="enter-icon" transform="translate(1727.000000, 1024.000000)">
          <rect
            id="Rectangle-4"
            stroke="#383838"
           strokeWidth="4"
            x="29"
            y="2"
            width="98"
            height="132"
            rx="5"
          />
          <rect
            id="Rectangle"
            fill="#FFFFFF"
            x="5"
            y="59"
            width="54"
            height="19"
          />
          <g
            id="Group"
            transform="translate(0.000000, 43.000000)"
            stroke="#383838"
            stroke-linecap="round"
           strokeWidth="4"
          >
            <g id="right-arrow" transform="translate(49.000000, 0.000000)">
              <path
                d="M0.0867553499,25.1577287 L22.4696356,49.9211356"
                transform="translate(11.278195, 37.539432) scale(1, -1) translate(-11.278195, -37.539432) "
              />
              <path
                d="M0.0867553499,0.0788643533 L22.4696356,24.8422713"
              />
            </g>
            <path d="M70.5,25.5 L0.5,25.5" id="Line-2" />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default EnterIcon;



// WEBPACK FOOTER //
// ./src/components/SVG/EnterIcon.js